import React from 'react'
import OnboardingContainer from '../components/onboarding/OnboardingContainer.tsx'

const OnboardingPage: React.FC = () => {
  return <OnboardingContainer />
}

export default OnboardingPage
